/* ==========================================================================
   BELORA — SKIMS PURE · hızlı ekleme (Complete Your Routine)
   Sepete ekleme Prestige'in <product-form>'una aittir. Bu dosya yalnız doğru
   varyantı forma yazar ve submit eder; fetch, hata, sepet çekmecesinin
   açılması ve yenilenmesi Prestige'de kalır — ikinci bir sepet motoru yok.
   ========================================================================== */

(function () {
  'use strict';
  // Every rail section includes this file; the quick-add below binds per card
  // and must bind once.
  if (window.__skQuickAdd) return;
  window.__skQuickAdd = true;

  var roots = document.querySelectorAll('[data-sk-qa]');
  if (!roots.length) return;

  /* Bir kart eklerken ikinci tık aynı ürünü tekrar göndermesin. Prestige
     submitter'a aria-busy koyuyor ama bizim submitter'ımız görünmez, bu yüzden
     kilidi burada tutuyoruz. */
  var inFlight = Object.create(null);

  function panelOf(el) { return el.querySelector('[data-sk-qa-panel]'); }

  Array.prototype.forEach.call(roots, function (root) {
    var trigger = root.querySelector('[data-sk-qa-open]');
    var panel = panelOf(root);
    var form = root.querySelector('.sk-qa__form');
    var idInput = root.querySelector('[data-sk-qa-id]');
    var submit = root.querySelector('[data-sk-qa-submit]');
    var errBox = root.querySelector('[data-sk-qa-error]');
    if (!trigger || !panel || !form || !idInput || !submit) return;

    trigger.addEventListener('click', function () {
      var open = trigger.getAttribute('aria-expanded') === 'true';
      trigger.setAttribute('aria-expanded', open ? 'false' : 'true');
      panel.hidden = open;
      if (!open) {
        // Klavye kullanıcısı açtığında ilk seçilebilir bedene git.
        var first = panel.querySelector('[data-sk-qa-variant]:not([aria-disabled="true"])');
        if (first) first.focus();
      }
    });

    panel.addEventListener('click', function (event) {
      var chip = event.target.closest('[data-sk-qa-variant]');
      if (!chip) return;

      if (chip.getAttribute('aria-disabled') === 'true') {
        // Tükenmiş beden: sessizce yutma, neden olmadığını söyle.
        if (errBox) {
          errBox.textContent = root.getAttribute('data-soldout-msg') || 'Bu beden tükendi.';
          errBox.hidden = false;
        }
        return;
      }

      var id = chip.getAttribute('data-sk-qa-variant');
      if (inFlight[id]) return;                       // hızlı çift tık
      inFlight[id] = true;

      if (errBox) errBox.hidden = true;
      idInput.value = id;
      idInput.disabled = false;
      chip.setAttribute('aria-busy', 'true');

      /* requestSubmit(): submit olayını GERÇEKTEN tetikler, böylece
         Prestige'in ProductForm dinleyicisi devreye girer. form.submit()
         olayı atlar ve sayfayı yeniden yükler. */
      if (typeof form.requestSubmit === 'function') form.requestSubmit(submit);
      else submit.click();

      window.setTimeout(function () {
        inFlight[id] = false;
        chip.removeAttribute('aria-busy');
      }, 1200);
    });

    form.addEventListener('cart:error', function (event) {
      var msg = event.detail && (event.detail.error || event.detail.description || event.detail.message);
      if (errBox && msg) { errBox.textContent = msg; errBox.hidden = false; }
      Array.prototype.forEach.call(panel.querySelectorAll('[aria-busy]'), function (c) { c.removeAttribute('aria-busy'); });
      inFlight = Object.create(null);
    });

    // Eklendikten sonra paneli kapat: sepet çekmecesi zaten açılıyor.
    form.addEventListener('variant:add', function () {
      trigger.setAttribute('aria-expanded', 'false');
      panel.hidden = true;
      inFlight = Object.create(null);
    });
  });
})();

/* ==========================================================================
   Portrait rails — arrows, and rails that would only repeat another

   Arrows, measured (vf-sk-rail-arrows-1440.json): "See next products" moves
   the rail by one full view — six cards, 1400px at 1440 — in about 300ms,
   easing out, and from the end it rewinds to the start; "previous" does the
   mirror. The reference never hides them. Ours read disabled when the rail has
   nothing to page instead of doing nothing, which would be a dead control.

   Repeats: the reference's rails always hold different products. BELORA's
   catalogue is small, so two sources can return the very same products — the
   collection, Shopify's "related" and Complete the Look, say. A product rail
   whose products have ALL been shown by a rail above it (Complete the Look
   included) adds nothing but a copy, so it is taken out; the first rail in the
   page stays. Identical sets were not enough: a rail of two products already in
   the band above is the same repetition to the shopper. Rails from server-side sources wait (data-sk-rail-wait) until
   Shopify's recommendations above them have arrived, so a copy never flashes
   on screen and then vanishes.
   ========================================================================== */
(function () {
  'use strict';
  if (window.__skRails) return;
  window.__skRails = true;

  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  function trackOf(rail) { return rail.querySelector('[data-sk-rail-track]'); }
  function maxScroll(t) { return Math.max(0, t.scrollWidth - t.clientWidth); }

  function paint(rail) {
    var t = trackOf(rail);
    if (!t) return;
    var can = maxScroll(t) > 1;
    Array.prototype.forEach.call(rail.querySelectorAll('[data-sk-rail-prev], [data-sk-rail-next]'), function (b) { b.disabled = !can; });
  }

  var running = new WeakMap();
  function glide(t, to) {
    to = Math.max(0, Math.min(maxScroll(t), to));
    if (reduced.matches) { t.scrollLeft = to; return; }
    var from = t.scrollLeft, start = null, token = {};
    running.set(t, token);
    t.style.scrollSnapType = 'none';                // snapping would fight the frames
    function frame(ts) {
      if (running.get(t) !== token) return;
      if (start === null) start = ts;
      var k = Math.min(1, (ts - start) / 300);
      t.scrollLeft = from + (to - from) * (1 - Math.pow(1 - k, 3));
      if (k < 1) window.requestAnimationFrame(frame);
      else t.style.scrollSnapType = '';
    }
    window.requestAnimationFrame(frame);
  }

  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-sk-rail-prev], [data-sk-rail-next]');
    if (!b || b.disabled) return;
    var rail = b.closest('[data-sk-rail]');
    var t = rail && trackOf(rail);
    if (!t) return;
    var cs = getComputedStyle(t);
    var view = t.clientWidth - (parseFloat(cs.paddingLeft) || 0) - (parseFloat(cs.paddingRight) || 0) + (parseFloat(cs.columnGap) || 0);
    var max = maxScroll(t), at = t.scrollLeft;
    var to = b.hasAttribute('data-sk-rail-next') ? (at >= max - 1 ? 0 : at + view) : (at <= 1 ? max : at - view);
    glide(t, to);
  });

  function handles(rail) {
    return Array.prototype.map.call(rail.querySelectorAll('[data-wl-handle]'), function (c) {
      return c.getAttribute('data-wl-handle');
    });
  }
  function pendingBefore(rail) {
    var recs = document.querySelectorAll('product-recommendations');
    for (var i = 0; i < recs.length; i++) {
      if (recs[i].childElementCount === 0 && (recs[i].compareDocumentPosition(rail) & Node.DOCUMENT_POSITION_FOLLOWING)) return true;
    }
    return false;
  }
  var settled = false;
  function sweep() {
    // Products the page has already shown, in reading order; the Complete the Look band
    // (data-sk-rail="square") counts too. A portrait rail stays only if it brings at least one
    // product no rail above it has shown. gs-rails (13 Sep 2026) found "Benzer Ürünler" repeating
    // Complete the Look's three products on all four PDPs and "Bu Renkte Daha Fazlası" repeating
    // two of them, because only IDENTICAL portrait rails were compared and the band never was.
    var shown = Object.create(null);
    Array.prototype.forEach.call(document.querySelectorAll('[data-sk-rail]'), function (rail) {
      var hs = handles(rail);
      if (rail.getAttribute('data-sk-rail') !== 'portrait') {
        if (!rail.hidden) hs.forEach(function (h) { shown[h] = true; });
        return;
      }
      var waiting = !settled && rail.hasAttribute('data-sk-rail-wait') && pendingBefore(rail);
      var fresh = hs.some(function (h) { return !shown[h]; });
      var show = hs.length > 0 && fresh && !waiting;
      rail.hidden = !show;
      if (show) { hs.forEach(function (h) { shown[h] = true; }); paint(rail); }
    });
  }

  /* "Complete the Look" only scrolls when its cards do not fit. When they do,
     its track stops being a scroll container, so a card's size list can open
     downward past the band the way the reference's does instead of being
     clipped by a scroller that has nothing to scroll. */
  function settleLook() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-sk-rail="square"] [data-sk-rail-track]'), function (t) {
      t.classList.remove('is-static');
      if (t.scrollWidth <= t.clientWidth + 1) t.classList.add('is-static');
    });
  }

  function start() {
    settleLook();
    sweep();
    var mo = new MutationObserver(function () { window.requestAnimationFrame(sweep); });
    Array.prototype.forEach.call(document.querySelectorAll('product-recommendations'), function (r) {
      if (r.parentNode) mo.observe(r.parentNode, { childList: true, subtree: true });
    });
    // A recommendations request that never answers must not hold the rails
    // below it back for good.
    window.setTimeout(function () { settled = true; sweep(); }, 6000);
    window.addEventListener('resize', function () {
      settleLook();
      Array.prototype.forEach.call(document.querySelectorAll('[data-sk-rail="portrait"]:not([hidden])'), paint);
    }, { passive: true });
  }
  // A rail section swapped in after a cart change (sk-cart.js) arrives hidden
  // and unpainted; settle it the same way.
  document.addEventListener('sk:rails:refresh', function () { settled = true; settleLook(); sweep(); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
